
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 6.81l3.57-3.56a.83.83 0 011.18 1.18L9.19 8l3.56 3.57a.83.83 0 01-1.18 1.18L8 9.19l-3.57 3.56a.83.83 0 01-1.18-1.18L6.81 8 3.25 4.43a.83.83 0 011.18-1.18z"}})])
          )
        }
      }
    